import React from 'react';
import classnames from 'classnames';
import { arrayOf, node, oneOfType, string } from 'prop-types';
import { Tooltip } from '@fiverr-private/fit';
import { I18n } from '@fiverr-private/fiverr_context';

import './style.scss';

const DisclaimerTooltip = ({ children, disclaimerClassName }) => {
    const renderDisclaimerContent = () => (
        <div className="disclaimer-tooltip">
            <I18n k="machine_translation.disclaimer"/>
        </div>
    );

    return (
        <Tooltip className={classnames('disclaimer-tooltip-wrapper', disclaimerClassName)}
            position={Tooltip.POSITIONS.TOP}
            appendToBody={false}
            content={renderDisclaimerContent()}>
            {children}
        </Tooltip>
    );
};

DisclaimerTooltip.propTypes = {
    children: oneOfType([
        arrayOf(node),
        node
    ]),
    disclaimerClassName: string
};

export default DisclaimerTooltip;
